module.exports = __webpack_public_path__ + "static/house-9bc266bec82d7975b92dbc65cdb8a66f.png";